<template>
  <div class="price-display" :class="{ 'price-display-large': large }">
    <span class="price-current" aria-label="Поточна ціна">{{ price | money }}</span>
    <del v-if="discount" class="price-old" aria-label="Стара ціна">{{ oldPrice | money }}</del>
    <span v-if="discount && showDiscount" class="price-discount">−{{ discount }}%</span>
  </div>
</template>
<script>
import { formatMoney, discountPercent } from "../resources/js/helpers/money";
export default {
  props: { price: [Number, String], oldPrice: [Number, String], large: Boolean, showDiscount: Boolean },
  filters: { money: formatMoney },
  computed: { discount() { return discountPercent(this.price, this.oldPrice); } },
};
</script>
<style scoped>
.price-display { display: flex; align-items: baseline; flex-wrap: wrap; gap: 4px 8px; margin-top: 6px; }
.price-current { font: 700 16px/22px Inter, sans-serif; color: #075a63; }
.price-old { font: 400 12px/18px Inter, sans-serif; color: #595959; }
.price-display-large .price-current { font-size: 22px; line-height: 28px; }
.price-display-large .price-old { font-size: 14px; }
.price-discount { font: 600 12px/18px Inter, sans-serif; color: #a42020; }
</style>
